import { Quill } from 'react-quill';

const BlockEmbed = Quill.import('blots/block/embed');

class Clearer extends BlockEmbed {}
Clearer.blotName = 'clearer';
Clearer.className = 'ql-clearer';
Clearer.tagName = 'div';

export default Clearer;
